<template>
  <div class="page" id="list">
    <div class="MyPages">
      <div>
        <p>
          Hi,<span>{{ $global.realname }}</span
          >！
        </p>
      </div>
      <div class="right" @click="$router.push('/credit')" v-if="!$global.type">
        <p>My Pages</p>
        <img src="@/assets/iconMy.png" />
      </div>
    </div>
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index" @click="$router.push({path: '/detail', query: {id: `${index + 7}`}})">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>

    <div class="block vc">
      <img
        src="@/assets/NavVideoCourses.png"
        alt=""
        class="title"
      />

      <div class="courses">
        <div class="left">
          <img src="@/assets/01.png" data-id="1" @click="$router.push({path: '/detail', query: {id: 1}})" alt="" />
          <img src="@/assets/02.png" data-id="2" @click="$router.push({path: '/detail', query: {id: 2}})" alt="" />
        </div>
        <div class="right">
          <img src="@/assets/03.png" data-id="3" @click="$router.push({path: '/detail', query: {id: 3}})" alt="" />
          <img src="@/assets/04.png" data-id="4" @click="$router.push({path: '/detail', query: {id: 4}})" alt="" />
          <img src="@/assets/05.png" data-id="5" @click="$router.push({path: '/detail', query: {id: 5}})" alt="" />
        </div>
      </div>
    </div>


    <div class="block iaap">
      <img
        src="@/assets/NavIaap.png"
        alt=""
        class="title"
      />

      <div class="courses">
          <img src="@/assets/06.png" data-id="7" @click="$router.push({path: '/detail', query: {id: 7}})" alt="" />
          <img src="@/assets/07.png" data-id="8" @click="$router.push({path: '/detail', query: {id: 8}})" alt="" />
          <img src="@/assets/08.png" data-id="9" @click="$router.push({path: '/detail', query: {id: 9}})" alt="" />
          <img src="@/assets/09.png" data-id="10" @click="$router.push({path: '/detail', query: {id: 10}})" alt="" />
      </div>
    </div>

    <a href="http://ipingshan.sznews.com/node_310228.htm" class="toOutside">
      <img src="@/assets/toOutside.png" alt="">
    </a>


    <div class="block kq">
      <img
        src="@/assets/NavKnowledge.png"
        alt=""
        class="title"
      />

      <div class="courses">
          <img src="@/assets/10.png" data-id="483" @click="$router.push({path: '/game', query: {lib: 483}})" alt="" />
          <img src="@/assets/11.png" data-id="484" @click="$router.push({path: '/game', query: {lib: 484}})" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>
